/**
 * PMImagePicker - Wrapper around EnhancedLibrary for backward compatibility
 * 
 * This component is now a thin wrapper around EnhancedLibrary with inline mode enabled.
 * For new code, use EnhancedLibrary directly with inline={true} prop.
 * 
 * @deprecated Consider using EnhancedLibrary directly with inline={true}
 */
import EnhancedLibrary from "../dashboard/Media/EnhancedLibrary";

export const PMImagePicker = ({ module = null, module_param = null, ...props }) => {
  return (
    <EnhancedLibrary
      module={module}
      moduleParam={module_param}
      module_param={module_param}
      inline={true}
      {...props}
    />
  );
};
